import { HomepageActions, ReducerState } from "./types";
import { HomepageConfigType } from "../utils/types";
import {
  defaultOrderHeader,
  defaultOrderBody
} from "../constraints/defaultOrder";

export const initialState: ReducerState = {
  order: {
    default: {
      header: defaultOrderHeader,
      body: defaultOrderBody,
      unmapped: []
    }
  },
  eventInfo: {
    eventDate: null,
    eventName: {
      label: "",
      size: 0
    },
    eventSubtitle: {
      label: "",
      size: 0
    },
    eventDescription: {
      label: "",
      size: 0
    },
    trackAbbr: "",
    raceNumber: 0,
    promo: {
      link: "",
      label: ""
    }
  },
  ctaButtons: {},
  currentConfig: HomepageConfigType.DEFAULT,
  hasRequest: false,
  derbyBanner: undefined
};

export default (
  state: ReducerState = initialState,
  action: HomepageActions
) => {
  switch (action.type) {
    case "SET_HOMEPAGE_CONFIG":
      return {
        ...state,
        order: action.payload?.order || state.order,
        eventInfo: action.payload?.eventInfo || state.eventInfo,
        currentConfig: action.payload?.currentConfig || state.currentConfig,
        ctaButtons: action.payload?.ctaButtons || state.ctaButtons,
        derbyBanner: action.payload?.derbyBanner || state.derbyBanner
      };
    case "SET_HOMEPAGE_ORDER_ACTION":
      return {
        ...state,
        order: action.payload
      };
    case "SET_HOMEPAGE_EVENT":
      return {
        ...state,
        eventInfo: action.payload
      };
    case "SET_HOMEPAGE_EVENT_STATUS":
      return {
        ...state,
        currentConfig: action.payload
      };
    case "SET_HOMEPAGE_DERBY_RACE":
      return {
        ...state,
        derbyRace: action.payload
      };
    case "SET_HAS_REQUEST":
      return {
        ...state,
        hasRequest: true
      };
    default: {
      return state;
    }
  }
};
